/**
 * Generic helpers shared across pages.
 *
 * Note: we no longer use cookies to authenticate (the backend issues an
 * HttpOnly session cookie automatically). This module keeps just the
 * non-auth helpers (validation + date formatting) for now.
 */

export const setBodyPage = (pageName) => {
  document.querySelector('body')?.setAttribute('data-page', pageName);
};

export const validateValue = (type, value) => {
  let valid = false;
  switch (type) {
    case 'password':
      valid = /^.{6,}$/.test(value ?? '');
      break;
    case 'email':
      valid = String(value ?? '')
        .toLowerCase()
        .match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
      break;
    default:
      break;
  }
  return !!valid;
};

export const dateToString = (date) => {
  try {
    const year  = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day   = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  } catch (e) { return ''; }
};

export const dateToChinese = (date) => {
  try {
    const year  = date.getFullYear();
    const month = date.getMonth() + 1;
    const day   = date.getDate();
    return `${year}年${month}月${day}日`;
  } catch (e) { return ''; }
};

export const dateToTimeString = (date) => {
  try {
    const hours   = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${hours}:${minutes}`;
  } catch (e) { return ''; }
};

export const dateToTimeChinese = (date) => {
  try {
    const hours   = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const period         = hours < 12 ? '上午' : '下午';
    const formattedHours = hours % 12 === 0 ? 12 : hours % 12;
    return `${period} ${formattedHours}:${minutes}`;
  } catch (e) { return ''; }
};

export const showEmptyValueOrHyphen = (value, nullText = '-') =>
  value === '' || value === null || value === undefined ? nullText : value;

export const showEmptyZeroValueOrHyphen = (value, nullText = '-') =>
  value === '' || value === null || value === undefined || value === 0 ? nullText : value;

/**
 * Date & datetime formatters used everywhere in the system.
 *
 * Rule (see DIRECTIONS.md §0 「Date Format」):
 *   date     → 'YYYY-MM-DD'           e.g. '2026-09-16'
 *   datetime → 'YYYY-MM-DD HH:MM'    e.g. '2026-09-16 17:54'  (no seconds)
 *
 * Accepts Date, string, or null/undefined. Returns '' for empty.
 */
const pad2 = (n) => String(n).padStart(2, '0');

export const formatDate = (v) => {
  if (v == null || v === '') return '';
  const d = v instanceof Date ? v : new Date(v);
  if (isNaN(d.getTime())) return '';
  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
};

export const formatDatetime = (v) => {
  if (v == null || v === '') return '';
  const d = v instanceof Date ? v : new Date(v);
  if (isNaN(d.getTime())) return '';
  return `${formatDate(d)} ${pad2(d.getHours())}:${pad2(d.getMinutes())}`;
};
